import type { JSX, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Icon, type IconName } from '@/components/ui/icon';
import { Heading2 } from '@/components/blocks/typography';

interface EntityCardHeaderProps {
  title: string;
  icon?: IconName;
  subtitle?: ReactNode;
  id?: string | null;
  idLabel?: string | null;
  trailingContent?: ReactNode;
}

export function EntityCardHeader({
  title,
  icon,
  subtitle,
  id,
  idLabel,
  trailingContent,
}: EntityCardHeaderProps): JSX.Element {
  const resolvedIdLabel = idLabel === undefined ? 'Codice' : (idLabel ?? undefined);
  const iconMarkup = icon ? (
    <Icon name={icon} className="icon-lg flex-shrink-0 text-brand-blue-700" aria-hidden="true" />
  ) : null;

  return (
    <div className="flex items-start justify-between gap-3 border-b border-[var(--border-default)] pb-4">
      <div className={cn('flex min-w-0 flex-1 gap-3', iconMarkup ? '' : '')}>
        {iconMarkup}
        <div className="min-w-0 flex-1">
          <Heading2 className="truncate text-xl font-semibold text-text-primary">{title}</Heading2>
          {subtitle ? <p className="mt-1 text-sm text-text-secondary">{subtitle}</p> : null}
          {id ? (
            <p className="mt-1 truncate font-mono text-sm text-brand-blue-300">
              {resolvedIdLabel ? (
                <span className="mr-1">
                  {resolvedIdLabel.endsWith(':') ? resolvedIdLabel : `${resolvedIdLabel}:`}
                </span>
              ) : null}
              <span>{id}</span>
            </p>
          ) : null}
        </div>
      </div>
      {trailingContent}
    </div>
  );
}
